import './Subscription.scss';

import { SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { ISalesList, SalessProps } from './ISubscription';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getSubscription } from '../../Redux/Slicers/Sales/SubscriptionSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
// import SalesForm from './SalesForm';
import { FormikProps } from 'formik';
// import {
//   clearUpdateSalesState,
//   salessUpdateableData,
// } from '../../Redux/Slicers/Sales/UpdateSalesSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';
import Select from "../../Components/Select/Select";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { getLocation } from "../../Redux/Slicers/Location/LocationSlicer";
// import {
//   clearDeleteSales,
//   deleteSales,
// } from '../../Redux/Slicers/Sales/DeleteSalesSlice';
// import { clearAddSalesState } from '../../Redux/Slicers/Sales/AddSalesSlicer';

const Sales: FunctionComponent<SalessProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.Sales);
  const [open, setOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>("");
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<ISalesList>>();
  const { data: projectData } = useAppSelector((state) => state?.Location);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
 const [sortField, setSortField] = useState("created_at");
 const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
 console.log(projectData);

 // const { data: updateSales, updateableDate } = useAppSelector(
 //   (state) => state.UpdateSales
 // );
 // const { data: addSales } = useAppSelector((state) => state.AddSales);
 // const { data: deleteSalesData } = useAppSelector(
 //   (state) => state.DeleteSales
 // );

 // const isUpdateable =
 //   updateableDate && Object.keys(updateableDate).length !== 0;

 const column: Columns = [
   {
     field: "index",
     renderHeader: () => <b>S.No</b>,
     flex: 1,
     headerAlign: "center",
     align: "center",
     type: "number",
     maxWidth: 90,
     sortable: false,
   },
   {
     field: "first_name",
     renderHeader: () => <b>Owner</b>,
     flex: 1,
     type: "string",
     maxWidth: 130,
   },
   {
     field: "vehicle_plate_no",
     renderHeader: () => <b>Vehicle No</b>,
     flex: 1,
     type: "string",
     maxWidth: 130,
   },
   {
     field: "location_name",
     renderHeader: () => <b>Location</b>,
     flex: 1,
     type: "string",
   },

   {
     field: "payment_type",
     renderHeader: () => <b>Payment Type</b>,
     flex: 1,
     type: "string",
     sortable: false,

     renderCell: (params) => {
       if (params.value === "MEMBERSHIP") {
         return "Manual";
       } else if (params.value === "MEMBERSHIP-AUTO") {
         return "Auto";
       } else {
         return params.value || "N/A"; // fallback
       }
     },
   },
   {
     field: "date",
     renderHeader: () => <b>Payment Date</b>,
     flex: 1,
     type: "string",
     //  sortable: false,
   },

   {
     field: "next_payment_date",
     renderHeader: () => <b>Next Payment Date</b>,
     flex: 1,
     type: "string",
     //  sortable: false,
   },

   {
     field: "package_name",
     renderHeader: () => <b>Package Name</b>,
     flex: 1,
     type: "string",
     sortable: false,
     renderCell: (params) => (params.value ? params.value : "-"),
   },

   {
     field: "package_type",
     renderHeader: () => <b>Package Type</b>,
     flex: 1,
     type: "string",
     sortable: false,
     renderCell: (params) => (params.value ? params.value : "-"),
   },
   {
     field: "package_days",
     renderHeader: () => <b>Package Count</b>,
     flex: 1,
     type: "string",
     renderCell: (params) => (params.value ? params.value : "-"),
   },

   {
     field: "Amount",
     renderHeader: () => <b>Amount Paid</b>,
     flex: 1,
     type: "string",
     maxWidth: 130,

     // valueGetter: (params: GridValueGetterParams<ISalesList>) =>
     //   params.row.role?.role_name,
   },
   // {
   //   field: 'status',
   //   renderHeader: () => <b>Status</b>,
   //   flex: 1,
   //   type: 'boolean',
   //   maxWidth: 190,

   //   renderCell: (params) => (
   //     <div>{params.value ? 'Active' : 'In-active'}</div>
   //   ),
   //   cellClassName: (params) => (params.value ? 'active' : 'inactive'),
   // },
   // {
   //   field: 'action',
   //   renderHeader: () => <b>Action</b>,
   //   flex: 1,
   //   type: 'actions',
   //   getActions: (params: GridRowParams<any>) => [
   //     <GridActionsCellItem
   //       key="Edit"
   //       label="Edit"
   //       icon={<Edit className="action_icons" />}
   //       onClick={() => {
   //         dispatch(salessUpdateableData(params.row));
   //         setOpen(true);
   //       }}
   //     />,
   //     <GridActionsCellItem
   //       key="Delete"
   //       label="Delete"
   //       icon={<Delete className="action_icons" />}
   //       onClick={() => {
   //         setDeleteOpen(true);
   //         setDeleteableName(params.row.name ?? '');
   //         setDeleteableId(params.row.id!);
   //       }}
   //     />,
   //   ],
   //   cellClassName: 'action_cell',
   // },
 ];

 useEffect(() => {
   // console.log('renderd');

   // dispatch(getSubscription(null));
   dispatch(getLocation());
 }, []);

 // useEffect(() => {
 //   return () => {
 //     dispatch(clearAddSalesState());
 //     dispatch(clearUpdateSalesState());
 //     dispatch(clearDeleteSales());
 //   };
 // }, []);

 const data1 = data?.response?.data;
 console.log(data1);

 const salesData = Array.isArray(data1)
   ? data1.map((sales, index) => ({
       ...sales,
       id: sales?._id,
       index: page * pageSize + (index + 1), // ✅ fixed serial number
       vehicle_plate_no: sales?.vehicle_id?.vehicle_plate_no,
       location_name: sales?.location_id?.location_name,
       first_name: sales?.owner_id?.first_name,
       check_in: sales?.check_in
         ? new Date(sales?.check_in).toISOString().split("T")[0]
         : "N/A",
       check_out: sales?.check_out
         ? new Date(sales?.check_out).toISOString().split("T")[0]
         : "N/A",
       date: new Date(sales?.created_at ?? Date.now())
         .toISOString()
         .split("T")[0],
       package_name: sales?.package_management_id?.package_name,
       package_type: sales?.package_management_id?.package_type,
       package_days: sales?.package_management_id?.package_days,
       next_payment_date: sales?.user_designation_vehicle_id?.date
         ? new Date(sales?.user_designation_vehicle_id?.date)
             ?.toISOString()
             ?.split("T")[0]
         : "-",
     }))
   : [];

 const locationData = projectData?.response?.data;

 const projects = Array.isArray(locationData)
   ? locationData.map((project) => ({
       label: project.location_name,
       value: project._id!,
     }))
   : [];

 const salesForm = (data: FormikProps<ISalesList>) => {
   setFormik(data);
 };

 console.log(salesData);

 useEffect(() => {
   dispatch(getSubscription({ page, pageSize, sortField, sortOrder })); // 🔑 pass to backend
 }, [page, pageSize, dispatch, sortField, sortOrder]);

  return (
    <>
      <Table
        rows={salesData ?? []}
        columns={column}
        rowCount={(data?.response as any)?.total ?? 0}
        onPageChange={(newPage, newPageSize) => {
          setPage(newPage);
          setPageSize(newPageSize);
        }}
         onSortChange={(field, order) => {
          if (field && order) {
            setSortField(field);
            setSortOrder(order);
          }
        }}>
        <CustomToolbar>
          <h6>Supscription</h6>

          <Select
            id="locationId"
            name="locationId"
            className="project_name"
            placeholder="Location Name"
            shrink={false}
            size="small"
            options={projects}
            onChange={(_, value: any) => {
              if (value) {
                const projectValue: any = value as AutocompleteOption;

                console.log(projectValue?.value);

                // dispatch(getSubscription(projectValue?.value));
                dispatch(
                  getSubscription({ page: 0, pageSize, location: value?.value })
                );
              } else {
                dispatch(getSubscription({ page: 0, pageSize }));

                // dispatch(getSubscription(null));
              }
            }}
          />
          <TableSearch />
        </CustomToolbar>
      </Table>
    </>
  );
};

export default Sales;
